import { render, staticRenderFns } from "./daliyDeatil.vue?vue&type=template&id=6539924e&scoped=true"
import script from "./daliyDeatil.vue?vue&type=script&lang=js"
export * from "./daliyDeatil.vue?vue&type=script&lang=js"
import style0 from "./daliyDeatil.vue?vue&type=style&index=0&id=6539924e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6539924e",
  null
  
)

export default component.exports